import { ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { CatalogOperatorReducer } from "../reducer/CatalogOperatorReducer";

const CatalogOperatorContext = createContext({
  state: CatalogOperatorReducer.getInitialState(),
  actions: CatalogOperatorReducer.actions,
});

export const useCatalogOperatorContext = () =>
  useContext(CatalogOperatorContext);

export const CatalogOperatorProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [state, actions] = useComplexState({
    initialState: CatalogOperatorReducer.getInitialState(),
    reducers: CatalogOperatorReducer.caseReducers,
  });
  return (
    <CatalogOperatorContext.Provider value={{ state, actions }}>
      {children}
    </CatalogOperatorContext.Provider>
  );
};
